import React, { useEffect, useRef } from 'react';

interface AdLeaderboard2Props {
  className?: string;
}

const AdLeaderboard2: React.FC<AdLeaderboard2Props> = ({ className }) => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current || !adContainerRef.current) return;
    
    // Create and inject the options script
    const optionsScript = document.createElement('script');
    optionsScript.type = 'text/javascript';
    optionsScript.textContent = `
      atOptions = {
        'key' : 'b05e5e9ae1565e40480c3451c4c0d5fb',
        'format' : 'iframe',
        'height' : 90,
        'width' : 728,
        'params' : {}
      };
    `;
    
    // Create and inject the invoke script
    const invokeScript = document.createElement('script');
    invokeScript.type = 'text/javascript';
    invokeScript.src = '//resideour.com/b05e5e9ae1565e40480c3451c4c0d5fb/invoke.js';
    
    // Append all elements to the container
    adContainerRef.current.appendChild(optionsScript);
    adContainerRef.current.appendChild(invokeScript);
    
    isScriptInjected.current = true;
    
    // Cleanup function
    return () => {
      if (adContainerRef.current) {
        adContainerRef.current.innerHTML = '';
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div 
      ref={adContainerRef} 
      className={`ad-leaderboard2 w-full overflow-hidden ${className || ''}`}
      style={{ height: '90px', maxWidth: '728px', margin: '0 auto' }}
    />
  );
};

export default AdLeaderboard2;